import { render, staticRenderFns } from "./CardsSwitcher.vue?vue&type=template&id=7edd8f61&"
import script from "./CardsSwitcher.vue?vue&type=script&lang=js&"
export * from "./CardsSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports